import { Partition, Range, Constant } from "@pdfking/tfunc"

/** Month `month` (January the 1st) of `year` as its weeks from Monday: each
 * day its number, null for one of the month before or after. */
export const MonthWeeks = (year: number, month: number): (number | null)[][] => {
  const before = (new Date(Date.UTC(year, month - 1, 1)).getUTCDay() + 6) % 7
  const days = new Date(Date.UTC(year, month, 0)).getUTCDate()
  const cells = [...Range(before)].map(Constant(null))
  const weeks = [...Partition([...cells, ...Range(1, days)], 7)]
  return weeks.map(week => [...week, ...[...Range(7 - week.length)].map(Constant(null))])
}
